module.exports = __webpack_public_path__ + "static/media/moon.22f63b3b.png";